import { render, staticRenderFns } from "./ObjectList.vue?vue&type=template&id=09db7b6c&"
import script from "./ObjectList.vue?vue&type=script&lang=js&"
export * from "./ObjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports